import { render, staticRenderFns } from "./receita.vue?vue&type=template&id=43120623&"
import script from "./receita.vue?vue&type=script&lang=js&"
export * from "./receita.vue?vue&type=script&lang=js&"
import style0 from "./receita.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports